// Auto-generated normalizer for table: CAR_BOOKING.CatEstadoReserva
export function catEstadoReservaNormalize(row) {
  return {
    idEstadoReserva: row.idEstadoReserva ?? row.IdEstadoReserva ?? row['idEstadoReserva'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['clave'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}